import useAuth from "./useAuth";
import { useFetch } from "../shared/ui/ui";

/** The four roles every fund starts with, for whoever cannot read the list. */
const BUILT_IN = [
  { key: "member", name: "Member" },
  { key: "director", name: "Director" },
  { key: "secretary", name: "Secretary" },
  { key: "president", name: "President" },
];

/**
 * The roles a member can be given in the open fund — its own, custom ones
 * included — from Roles and permissions when this person may read it.
 * There is no "admin" role any more; the forms used to offer one.
 */
const useRoleOptions = () => {
  const { organisation, can } = useAuth();
  const roles = useFetch(organisation?._id ? `/api/security/${organisation._id}/roles` : null, {
    skip: !can("security", "view"),
  });
  return Array.isArray(roles.data) && roles.data.length
    ? roles.data.map((role) => ({ key: role.key, name: role.name }))
    : BUILT_IN;
};

export default useRoleOptions;
